import ru from 'date-fns/locale/ru';
import en from 'date-fns/locale/en-US';
import Cookies from 'js-cookie';

import { LangValueType } from 'core/types';

//todo added settings base paths [home,login,registration,account]

let API_PATH = process.env.REACT_APP_API_PATH;
const IS_DEV_STAGE = !!window.location.origin.match(/(localhost|avgr.it)/);

if (IS_DEV_STAGE) {
  const search = new URLSearchParams(window.location.search);
  let apiUrl = search.get('apiUrl') || Cookies.get('dev_api_url');

  if (apiUrl && apiUrl[apiUrl.length - 1] === '/') {
    apiUrl = apiUrl.substring(0, apiUrl.length - 1);
  }

  if (apiUrl) {
    Cookies.set('dev_api_url', apiUrl);
    API_PATH = apiUrl;
  }
}

const CORE_SETTINGS: {
  environment: 'development' | 'production' | 'test';
  isDevelopStage: boolean;
  apiPath: string | undefined;
  nameApiHeaderToken: string;
  WPApiPath: string | undefined;
  authTokenStorage: string;
  defaultLanguage: LangValueType;
  excludeLanguage: LangValueType;
  displayedLanguages: LangValueType[];
  localeLanguages: { [K in LangValueType]?: Locale };
  pathHome: string;
  pathLogin: string;
  gtmId: string;
} = {
  environment: process.env.NODE_ENV,
  isDevelopStage: IS_DEV_STAGE,
  apiPath: API_PATH,
  nameApiHeaderToken: 'apikey',
  WPApiPath: process.env.REACT_APP_WP_API_PATH,
  authTokenStorage: 'authorization_token',
  defaultLanguage: LangValueType.en,
  excludeLanguage: LangValueType.en,
  displayedLanguages: [LangValueType.en, LangValueType.ru],
  localeLanguages: { [LangValueType.en]: en, [LangValueType.ru]: ru },
  pathHome: '/',
  pathLogin: '/login',
  gtmId: 'gtm_id',
};

export default CORE_SETTINGS;
